module.exports = __webpack_public_path__ + "static/media/Portrait-10263.fc1067ab.jpg";